<template>
  <router-view />
</template>

<script setup lang="ts">
// 主应用组件 - 使用路由视图
</script>

<style>
/* 全局样式已在 style.css 中定义 */
</style>
